<template>
  <div class="w-full py-8">
    <swiper :options="planswiperOption" class="">
      <swiper-slide
        class="m-2 cursor-pointer rounded-12px"
        v-for="item in related_items"
        :key="item.objectId"
      >
        <div class="bg-white p-5 border rounded-12px">
          <div class="">
            <img
              :src="item.image"
              class="object-cover bg-fas w-full h-236px border-round"
              alt="banh"
            />
            <div class="flex w-full mt-3 items-center">
              <div class="w-10/12">
                <h2 class="text-dark text-xl font-semibold flex items-center">
                  {{ item.heads }}
                </h2>
              </div>
              <div class="w-2/12 flex justify-end">
                <div
                  class="flex justify-center bg-light-secondary rounded-full items-center w-10 h-10"
                >
                  <feather-icon
                    icon="ChevronRightIcon"
                    svgClasses="w-5 h-5"
                    class="text-secondary font-semibold flex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      planswiperOption: {
        slidesPerView: 1.1,
        observer: true,
        observeParents: true,
        spaceBetween: 25,
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      related_items: [
        {
          name: "Template 1",
          image: require("@/assets/images/icons/Controll center.svg"),
          heads: "Unlock the power marketing with marcom",
        },
        {
          name: "Template 2",
          image: require("@/assets/images/icons/Controll center.svg"),
          heads: "Unlock the power marketing with marcom",
        },
        {
          name: "Template 3",
          image: require("@/assets/images/icons/Controll center.svg"),
          heads: "Unlock the power marketing with marcom",
        },
      ],
      products: [],
    };
  },

  computed: {
    ...mapState("admin", ["selectedPlan"]),
  },
};
</script>
